<div class="two-factor-authentication">
  <div>
    <p class="two-factor-authentication__title">
      Autenticação multifator detectada
    </p>
    <p class="two-factor-authentication__subtitle">
      Você possui uma autenticação multifator ativa via
      <strong>{{ twoFactorAuthenticationName }}.</strong>
      Insira o código gerado no app para acessar sua conta.
    </p>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
    <aprova-input
      #verificationCodeInput
      label="Insira seu código abaixo"
      placeholder="Digite o código"
      [control]="verificationCodeFormControl"
      inputClass="text-2xl text-center"
    >
      <span *ngIf="errorMessage() && errorMessage().length > 0" error-message class="text-sm text-red-600 dark:text-red-500">
        {{ errorMessage() }}
      </span>
    </aprova-input>

    <aprova-button
      buttonType="submit"
      label="Confirmar"
      buttonClass="inline-flex items-center justify-center bg-aprova px-3 md:py-1.5 py-3 sm:text-sm leading-6 text-white hover:bg-aprova/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      [disabled]="form.invalid || loading()"
    />
  </form>
</div>
